export default "__VITE_PUBLIC_ASSET__4a0433ee__"